import { ICafeListItemViewModel } from "@dining/api-client";
import { Pivot, PivotItem, Stack } from "@fluentui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeUpdateCafeMode, openPanel } from "../../reducers/diningReducer";
import { cafeSelector, updateCafeModeSelector } from "../../selectors/diningSelector";
import { UpdateCafeForm } from "./UpdateCafeForm";

export const UpdateCafe = () => {
  const selectedCafe: ICafeListItemViewModel | undefined = useSelector(cafeSelector);
  const updateCafeMode: string = useSelector(updateCafeModeSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openPanel());
  }, []);

  const toggleUpdateCafeMode = (p: PivotItem) => {
    p.props.itemKey
      ? dispatch(changeUpdateCafeMode(p.props.itemKey))
      : updateCafeMode === "Add"
      ? dispatch(changeUpdateCafeMode("Edit"))
      : dispatch(changeUpdateCafeMode("Add"));
  };

  return (
    <Stack verticalFill={true} verticalAlign="space-between">
      <Pivot
        aria-label="Add or Edit Cafe Selector"
        selectedKey={updateCafeMode}
        onLinkClick={(p: PivotItem) => toggleUpdateCafeMode(p)}
      >
        <PivotItem headerText="Add cafe" itemKey="Add">
          <UpdateCafeForm />
        </PivotItem>
        {selectedCafe && (
          <PivotItem headerText="Edit cafe" itemKey="Edit">
            <UpdateCafeForm />
          </PivotItem>
        )}
      </Pivot>
    </Stack>
  );
};

export default UpdateCafe;
